export var ACCOUNT_EVENT_IDS = {
  DEPOSIT_REQUIRED: 'event.deposit.required',
  RECOVER_REQUESTED: 'event.account.recovery.requested',
  REOPEN_REQUESTED: 'event.account.reopen.requested',
  RESET_PASSWORD_REQUIRED: 'event.account.password.reset.required',
  FAQ_PAGE_REQUESTED: 'event.faq.page.requested',
  LIVE_CHAT_REQUESTED: 'event.live.chat.requested',
  LOGIN_REQUESTED: 'event.account.login.requested',
  REGISTRATION_REQUESTED: 'event.account.registration.requested',
  API_CALL_INVALID: 'event.account.api.call.invalid',
  INVALID_STATE: 'event.account.state.invalid',
  OPERATION_FAILED: 'event.account.operation.failed',
  WELCOME_MESSAGES_REQUESTED: 'event.wm.campaign.requested',
  WELCOME_MESSAGES_CAMPAIGN_DISPLAYED: 'event.wm.campaign.displayed',
  WELCOME_MESSAGES_NAVIGATE_REQUESTED: 'event.wm.navigate.requested',
  BETSLIP_REQUESTED: 'event.betslip.requested',
  PLACE_BET_REQUESTED: 'event.place.bet.requested',
  LAUNCH_GAME_REQUESTED: 'event.launch.game.requested'
};
//# sourceMappingURL=AccountEventIds.js.map